import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { getUrlWithParams } from '@helpers/site'
import * as catalogApi from '@api/catalog'
import * as S from './Search.styled'
import IconSearch from '../../Icons/IconSearch'
import { useShipment } from '@entities/shipment/model'
import { SuggestionsSearchDesktop } from 'src/features/suggestions/ui/desktop'
import {
    $isOpenedSearchSection,
    closeSearchSection,
    openSearchSection,
    useOnChangeSearchText,
    useSearchText
} from 'src/features/search-goods/model'
import { useEvent, useStore } from 'effector-react'
import { searchSuggestion } from 'src/features/suggestions/model'

const Search = () => {
    //const router = useRouter()
    const shipment = useShipment()
    const onChangeSearchText = useOnChangeSearchText()
    const openSearchSectionHandler = useEvent(openSearchSection)
    const isVisibleSuggestions = useStore($isOpenedSearchSection)
    const closeSearchSectionHandler = useEvent(closeSearchSection)
    const searchText = useSearchText()
    const searchHandler = useEvent(searchSuggestion)
    const [tags, setTags] = useState([])

    const initTags = async () => {
        const searchTags = await catalogApi.getSearchUnderlineTags(shipment)
        setTags(searchTags)
    }

    useEffect(() => {
        // noinspection JSIgnoredPromiseFromCall
        initTags()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const keyDownHandler = async (e) => {
        if (e.key === 'Enter' && searchText.length > 2) {
            searchHandler(searchText)
        }
    }
    const clickSearch = async () => {
        if (searchText.length > 2) {
            searchHandler(searchText)
        }
    }
    const changeSearch = (e) => {
        onChangeSearchText(e?.target?.value || '')
    }

    return (
        <S.Container>
            {isVisibleSuggestions && <S.SerachBlockSuggestions onClick={closeSearchSectionHandler} />}
            <S.SerachBlock>
                <S.Input
                    data-search-input
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    value={searchText}
                    onFocus={openSearchSectionHandler}
                    onChange={changeSearch}
                    onKeyDown={keyDownHandler}
                    placeholder="Поиск по наименованию, МНН, симптому, бренду"
                />
                <S.IconContainer data-search-submit onClick={clickSearch}>
                    <IconSearch />
                </S.IconContainer>
                <SuggestionsSearchDesktop />
            </S.SerachBlock>

            {tags && tags.length > 0 ? (
                <S.TagsBlock>
                    Например:{' '}
                    {tags.map((x) => (
                        <Link
                            key={x.id}
                            href={getUrlWithParams('/catalog/search', [{ name: 'q', value: x.title }])}
                            passHref
                            legacyBehavior>
                            <S.TagItem>
                                <S.TagSpan>{x.title}</S.TagSpan>
                            </S.TagItem>
                        </Link>
                    ))}
                </S.TagsBlock>
            ) : (
                <React.Fragment />
            )}
        </S.Container>
    )
}

export default Search
